import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _19c08d12 = () => interopDefault(import('../../../pages/metals.vue' /* webpackChunkName: "pages/metals" */))
const _a28def82 = () => interopDefault(import('../../../pages/collections.vue' /* webpackChunkName: "pages/collections" */))
const _7dfb3afb = () => interopDefault(import('../../../pages/configurator.vue' /* webpackChunkName: "pages/configurator" */))
const _16e72b65 = () => interopDefault(import('../../../pages/diamonds.vue' /* webpackChunkName: "pages/diamonds" */))
const _0fa7fa7c = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _fc141604 = () => interopDefault(import('../../../pages/engagementRingsFastDelivery.vue' /* webpackChunkName: "pages/engagementRingsFastDelivery" */))
const _4409b1e3 = () => interopDefault(import('../../../pages/engraving.vue' /* webpackChunkName: "pages/engraving" */))
const _4ed97b72 = () => interopDefault(import('../../../pages/memoireRings.vue' /* webpackChunkName: "pages/memoireRings" */))
const _5e6addb3 = () => interopDefault(import('../../../pages/imprint.vue' /* webpackChunkName: "pages/imprint" */))
const _e54704c8 = () => interopDefault(import('../../../pages/diamondJewelry.vue' /* webpackChunkName: "pages/diamondJewelry" */))
const _791eaf32 = () => interopDefault(import('../../../pages/shops.vue' /* webpackChunkName: "pages/shops" */))
const _060975c6 = () => interopDefault(import('../../../pages/shoplogout.vue' /* webpackChunkName: "pages/shoplogout" */))
const _0c066a4c = () => interopDefault(import('../../../pages/magazine.vue' /* webpackChunkName: "pages/magazine" */))
const _b64031f0 = () => interopDefault(import('../../../pages/memoireRingsFullSizeMemoires.vue' /* webpackChunkName: "pages/memoireRingsFullSizeMemoires" */))
const _66c9526e = () => interopDefault(import('../../../pages/memoireRingsGrowingMemoires.vue' /* webpackChunkName: "pages/memoireRingsGrowingMemoires" */))
const _450dc9ef = () => interopDefault(import('../../../pages/onlineConsulting.vue' /* webpackChunkName: "pages/onlineConsulting" */))
const _201fc092 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _0e0fedb2 = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _0a322188 = () => interopDefault(import('../../../pages/consulting.vue' /* webpackChunkName: "pages/consulting" */))
const _40883628 = () => interopDefault(import('../../../pages/ringSizes.vue' /* webpackChunkName: "pages/ringSizes" */))
const _27bc6108 = () => interopDefault(import('../../../pages/sapphire.vue' /* webpackChunkName: "pages/sapphire" */))
const _c0ed3e02 = () => interopDefault(import('../../../pages/shopIndividualBeBrussels.vue' /* webpackChunkName: "pages/shopIndividualBeBrussels" */))
const _2608185f = () => interopDefault(import('../../../pages/sitemap.vue' /* webpackChunkName: "pages/sitemap" */))
const _765796b0 = () => interopDefault(import('../../../pages/styles.vue' /* webpackChunkName: "pages/styles" */))
const _81c33258 = () => interopDefault(import('../../../pages/sweepstake.vue' /* webpackChunkName: "pages/sweepstake" */))
const _0cd8a615 = () => interopDefault(import('../../../pages/weddingRings.vue' /* webpackChunkName: "pages/weddingRings" */))
const _afbea128 = () => interopDefault(import('../../../pages/urbanMining.vue' /* webpackChunkName: "pages/urbanMining" */))
const _6b2356ea = () => interopDefault(import('../../../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _83448524 = () => interopDefault(import('../../../pages/engagementRings.vue' /* webpackChunkName: "pages/engagementRings" */))
const _6e586682 = () => interopDefault(import('../../../pages/zweiklang.vue' /* webpackChunkName: "pages/zweiklang" */))
const _c18d5752 = () => interopDefault(import('../../../pages/zweiklangConfigurator.vue' /* webpackChunkName: "pages/zweiklangConfigurator" */))
const _3e27a63c = () => interopDefault(import('../../../pages/aboutPackaging.vue' /* webpackChunkName: "pages/aboutPackaging" */))
const _334c00a4 = () => interopDefault(import('../../../pages/aboutRjc.vue' /* webpackChunkName: "pages/aboutRjc" */))
const _70c0e335 = () => interopDefault(import('../../../pages/collectionsEngagementRings.vue' /* webpackChunkName: "pages/collectionsEngagementRings" */))
const _2c7c0ad7 = () => interopDefault(import('../../../pages/configuratorV2.vue' /* webpackChunkName: "pages/configuratorV2" */))
const _516d7204 = () => interopDefault(import('../../../pages/engagementRingsEntwined.vue' /* webpackChunkName: "pages/engagementRingsEntwined" */))
const _078b1b1a = () => interopDefault(import('../../../pages/engagementRingsEssentials.vue' /* webpackChunkName: "pages/engagementRingsEssentials" */))
const _46edee6c = () => interopDefault(import('../../../pages/engagementRingsHalo.vue' /* webpackChunkName: "pages/engagementRingsHalo" */))
const _4cd8080a = () => interopDefault(import('../../../pages/engagementRingsLabGrownDiamonds.vue' /* webpackChunkName: "pages/engagementRingsLabGrownDiamonds" */))
const _96092af8 = () => interopDefault(import('../../../pages/engagementRingsTensionRing.vue' /* webpackChunkName: "pages/engagementRingsTensionRing" */))
const _23b38611 = () => interopDefault(import('../../../pages/engravingFonts.vue' /* webpackChunkName: "pages/engravingFonts" */))
const _257a6437 = () => interopDefault(import('../../../pages/engravingInspiration.vue' /* webpackChunkName: "pages/engravingInspiration" */))
const _7941d609 = () => interopDefault(import('../../../pages/engravingSayings.vue' /* webpackChunkName: "pages/engravingSayings" */))
const _59950db0 = () => interopDefault(import('../../../pages/engravingSymbols.vue' /* webpackChunkName: "pages/engravingSymbols" */))
const _49ce008a = () => interopDefault(import('../../../pages/memoireRingsBestseller.vue' /* webpackChunkName: "pages/memoireRingsBestseller" */))
const _4b76baae = () => interopDefault(import('../../../pages/memoireRingsBudgetHigh.vue' /* webpackChunkName: "pages/memoireRingsBudgetHigh" */))
const _75b281f8 = () => interopDefault(import('../../../pages/memoireRingsBudgetLow.vue' /* webpackChunkName: "pages/memoireRingsBudgetLow" */))
const _32dc3e01 = () => interopDefault(import('../../../pages/memoireRingsBudgetMedium.vue' /* webpackChunkName: "pages/memoireRingsBudgetMedium" */))
const _5eb6c510 = () => interopDefault(import('../../../pages/memoireRingsCheap.vue' /* webpackChunkName: "pages/memoireRingsCheap" */))
const _6aae162b = () => interopDefault(import('../../../pages/memoireRingsColored.vue' /* webpackChunkName: "pages/memoireRingsColored" */))
const _bf2cf172 = () => interopDefault(import('../../../pages/memoireRingsGold.vue' /* webpackChunkName: "pages/memoireRingsGold" */))
const _448a0cd2 = () => interopDefault(import('../../../pages/memoireRingsHalfSetMemories.vue' /* webpackChunkName: "pages/memoireRingsHalfSetMemories" */))
const _4c214393 = () => interopDefault(import('../../../pages/memoireRingsPlatinum.vue' /* webpackChunkName: "pages/memoireRingsPlatinum" */))
const _25487fda = () => interopDefault(import('../../../pages/memoireRingsRedgold.vue' /* webpackChunkName: "pages/memoireRingsRedgold" */))
const _26b8ebd4 = () => interopDefault(import('../../../pages/memoireRingsRosegold.vue' /* webpackChunkName: "pages/memoireRingsRosegold" */))
const _a32a1d30 = () => interopDefault(import('../../../pages/memoireRingsRingsets.vue' /* webpackChunkName: "pages/memoireRingsRingsets" */))
const _ee9df73e = () => interopDefault(import('../../../pages/memoireRingsSignature.vue' /* webpackChunkName: "pages/memoireRingsSignature" */))
const _48b58cb8 = () => interopDefault(import('../../../pages/memoireRingsSlim.vue' /* webpackChunkName: "pages/memoireRingsSlim" */))
const _23d7b09c = () => interopDefault(import('../../../pages/memoireRingsConfigurator.vue' /* webpackChunkName: "pages/memoireRingsConfigurator" */))
const _6e49c747 = () => interopDefault(import('../../../pages/memoireRingsExclusive.vue' /* webpackChunkName: "pages/memoireRingsExclusive" */))
const _2b9a9f70 = () => interopDefault(import('../../../pages/memoireRingsAsWeddingRings.vue' /* webpackChunkName: "pages/memoireRingsAsWeddingRings" */))
const _596747d2 = () => interopDefault(import('../../../pages/memoireRingsWhite.vue' /* webpackChunkName: "pages/memoireRingsWhite" */))
const _6754ffe8 = () => interopDefault(import('../../../pages/diamondJewelrySignet.vue' /* webpackChunkName: "pages/diamondJewelrySignet" */))
const _e9688820 = () => interopDefault(import('../../../pages/diamondJewelry025Carat.vue' /* webpackChunkName: "pages/diamondJewelry025Carat" */))
const _f6eac2d0 = () => interopDefault(import('../../../pages/diamondJewelry050Carat.vue' /* webpackChunkName: "pages/diamondJewelry050Carat" */))
const _a357f7cc = () => interopDefault(import('../../../pages/diamondJewelry070Carat.vue' /* webpackChunkName: "pages/diamondJewelry070Carat" */))
const _b876739c = () => interopDefault(import('../../../pages/diamondJewelry100Carat.vue' /* webpackChunkName: "pages/diamondJewelry100Carat" */))
const _6957a8df = () => interopDefault(import('../../../pages/diamondJewelryBracelets.vue' /* webpackChunkName: "pages/diamondJewelryBracelets" */))
const _7c78d59f = () => interopDefault(import('../../../pages/diamondJewelryBestseller.vue' /* webpackChunkName: "pages/diamondJewelryBestseller" */))
const _7e218fc3 = () => interopDefault(import('../../../pages/diamondJewelryBudgetHigh.vue' /* webpackChunkName: "pages/diamondJewelryBudgetHigh" */))
const _1c7e3643 = () => interopDefault(import('../../../pages/diamondJewelryBudgetLow.vue' /* webpackChunkName: "pages/diamondJewelryBudgetLow" */))
const _662621d6 = () => interopDefault(import('../../../pages/diamondJewelryBudgetMedium.vue' /* webpackChunkName: "pages/diamondJewelryBudgetMedium" */))
const _2a0accb9 = () => interopDefault(import('../../../pages/diamondJewelryCollectionRings.vue' /* webpackChunkName: "pages/diamondJewelryCollectionRings" */))
const _57219471 = () => interopDefault(import('../../../pages/diamondJewelryConfigurator.vue' /* webpackChunkName: "pages/diamondJewelryConfigurator" */))
const _4bd1658e = () => interopDefault(import('../../../pages/diamondJewelryDelicateJewels.vue' /* webpackChunkName: "pages/diamondJewelryDelicateJewels" */))
const _668ae9e9 = () => interopDefault(import('../../../pages/diamondJewelryEarrings.vue' /* webpackChunkName: "pages/diamondJewelryEarrings" */))
const _7f035e85 = () => interopDefault(import('../../../pages/diamondJewelryColliers.vue' /* webpackChunkName: "pages/diamondJewelryColliers" */))
const _15157b92 = () => interopDefault(import('../../../pages/diamondJewelryExclusive.vue' /* webpackChunkName: "pages/diamondJewelryExclusive" */))
const _0ccb101c = () => interopDefault(import('../../../pages/diamondJewelryGold.vue' /* webpackChunkName: "pages/diamondJewelryGold" */))
const _283859e8 = () => interopDefault(import('../../../pages/diamondJewelryPlatinum.vue' /* webpackChunkName: "pages/diamondJewelryPlatinum" */))
const _e10a6a36 = () => interopDefault(import('../../../pages/diamondJewelryRedgold.vue' /* webpackChunkName: "pages/diamondJewelryRedgold" */))
const _6e8abf2a = () => interopDefault(import('../../../pages/diamondJewelryRosegold.vue' /* webpackChunkName: "pages/diamondJewelryRosegold" */))
const _2e5600e6 = () => interopDefault(import('../../../pages/diamondJewelrySets.vue' /* webpackChunkName: "pages/diamondJewelrySets" */))
const _2f7cb8ac = () => interopDefault(import('../../../pages/diamondJewelrySignature.vue' /* webpackChunkName: "pages/diamondJewelrySignature" */))
const _ef69c106 = () => interopDefault(import('../../../pages/diamondJewelryWhitegold.vue' /* webpackChunkName: "pages/diamondJewelryWhitegold" */))
const _7adc03be = () => interopDefault(import('../../../pages/aboutSustainability.vue' /* webpackChunkName: "pages/aboutSustainability" */))
const _051a5ff0 = () => interopDefault(import('../../../pages/aboutPhilosophy.vue' /* webpackChunkName: "pages/aboutPhilosophy" */))
const _49b867eb = () => interopDefault(import('../../../pages/aboutJewelryManufacturing.vue' /* webpackChunkName: "pages/aboutJewelryManufacturing" */))
const _1f3e3410 = () => interopDefault(import('../../../pages/aboutQuality.vue' /* webpackChunkName: "pages/aboutQuality" */))
const _6597c956 = () => interopDefault(import('../../../pages/aboutDesign.vue' /* webpackChunkName: "pages/aboutDesign" */))
const _c263bea4 = () => interopDefault(import('../../../pages/aboutService.vue' /* webpackChunkName: "pages/aboutService" */))
const _8e05f05e = () => interopDefault(import('../../../pages/aboutWeddingRingManufacturing.vue' /* webpackChunkName: "pages/aboutWeddingRingManufacturing" */))
const _7648f20e = () => interopDefault(import('../../../pages/ringSizesCalculator.vue' /* webpackChunkName: "pages/ringSizesCalculator" */))
const _01fb9972 = () => interopDefault(import('../../../pages/ringSizesTable.vue' /* webpackChunkName: "pages/ringSizesTable" */))
const _180e6600 = () => interopDefault(import('../../../pages/stylesIndividualStyle.vue' /* webpackChunkName: "pages/stylesIndividualStyle" */))
const _0995fd9a = () => interopDefault(import('../../../pages/weddingRingsBlack.vue' /* webpackChunkName: "pages/weddingRingsBlack" */))
const _36047594 = () => interopDefault(import('../../../pages/weddingRingsFinishes.vue' /* webpackChunkName: "pages/weddingRingsFinishes" */))
const _26090a50 = () => interopDefault(import('../../../pages/weddingRingsBestseller.vue' /* webpackChunkName: "pages/weddingRingsBestseller" */))
const _6cf2fe7e = () => interopDefault(import('../../../pages/weddingRingsForestGreen.vue' /* webpackChunkName: "pages/weddingRingsForestGreen" */))
const _22b79608 = () => interopDefault(import('../../../pages/weddingRingsBudgetHigh.vue' /* webpackChunkName: "pages/weddingRingsBudgetHigh" */))
const _38e585ea = () => interopDefault(import('../../../pages/weddingRingsBudgetLow.vue' /* webpackChunkName: "pages/weddingRingsBudgetLow" */))
const _7ed74662 = () => interopDefault(import('../../../pages/weddingRingsBudgetMedium.vue' /* webpackChunkName: "pages/weddingRingsBudgetMedium" */))
const _79c8af62 = () => interopDefault(import('../../../pages/weddingRingsCarbon.vue' /* webpackChunkName: "pages/weddingRingsCarbon" */))
const _1025f4f2 = () => interopDefault(import('../../../pages/weddingRingsCertificate.vue' /* webpackChunkName: "pages/weddingRingsCertificate" */))
const _9ce0612c = () => interopDefault(import('../../../pages/weddingRingsConfigurator.vue' /* webpackChunkName: "pages/weddingRingsConfigurator" */))
const _1403ea52 = () => interopDefault(import('../../../pages/weddingRingsCrown.vue' /* webpackChunkName: "pages/weddingRingsCrown" */))
const _5b1d4f54 = () => interopDefault(import('../../../pages/weddingRingsDiamonds.vue' /* webpackChunkName: "pages/weddingRingsDiamonds" */))
const _32b28c5f = () => interopDefault(import('../../../pages/weddingRingsGayLesbianCouples.vue' /* webpackChunkName: "pages/weddingRingsGayLesbianCouples" */))
const _317ccb39 = () => interopDefault(import('../../../pages/weddingRingsExclusive.vue' /* webpackChunkName: "pages/weddingRingsExclusive" */))
const _d71dd138 = () => interopDefault(import('../../../pages/weddingRingsFancy.vue' /* webpackChunkName: "pages/weddingRingsFancy" */))
const _40cb86cb = () => interopDefault(import('../../../pages/weddingRingsFrameSettings.vue' /* webpackChunkName: "pages/weddingRingsFrameSettings" */))
const _2fbb69e5 = () => interopDefault(import('../../../pages/weddingRingsPlain.vue' /* webpackChunkName: "pages/weddingRingsPlain" */))
const _62692b2c = () => interopDefault(import('../../../pages/weddingRingsCheap.vue' /* webpackChunkName: "pages/weddingRingsCheap" */))
const _aec757d6 = () => interopDefault(import('../../../pages/weddingRingsGold.vue' /* webpackChunkName: "pages/weddingRingsGold" */))
const _01880ae2 = () => interopDefault(import('../../../pages/weddingRingsHearts.vue' /* webpackChunkName: "pages/weddingRingsHearts" */))
const _19b88fed = () => interopDefault(import('../../../pages/weddingRingsClassic.vue' /* webpackChunkName: "pages/weddingRingsClassic" */))
const _3a0c14b1 = () => interopDefault(import('../../../pages/weddingRingsMen.vue' /* webpackChunkName: "pages/weddingRingsMen" */))
const _27a01c99 = () => interopDefault(import('../../../pages/weddingRingsMillgrif.vue' /* webpackChunkName: "pages/weddingRingsMillgrif" */))
const _15e5f414 = () => interopDefault(import('../../../pages/weddingRingsModern.vue' /* webpackChunkName: "pages/weddingRingsModern" */))
const _5574aaca = () => interopDefault(import('../../../pages/weddingRingsMokumeGane.vue' /* webpackChunkName: "pages/weddingRingsMokumeGane" */))
const _3164f961 = () => interopDefault(import('../../../pages/weddingRingsPlatinum.vue' /* webpackChunkName: "pages/weddingRingsPlatinum" */))
const _d0ede954 = () => interopDefault(import('../../../pages/weddingRingsRingSets.vue' /* webpackChunkName: "pages/weddingRingsRingSets" */))
const _34efd84c = () => interopDefault(import('../../../pages/weddingRingsRedgold.vue' /* webpackChunkName: "pages/weddingRingsRedgold" */))
const _5c318038 = () => interopDefault(import('../../../pages/weddingRingsRosegold.vue' /* webpackChunkName: "pages/weddingRingsRosegold" */))
const _5d970b51 = () => interopDefault(import('../../../pages/weddingRingsSecretHeart.vue' /* webpackChunkName: "pages/weddingRingsSecretHeart" */))
const _4be40853 = () => interopDefault(import('../../../pages/weddingRingsSignature.vue' /* webpackChunkName: "pages/weddingRingsSignature" */))
const _384ff31c = () => interopDefault(import('../../../pages/weddingRingsSlim.vue' /* webpackChunkName: "pages/weddingRingsSlim" */))
const _a5165cb8 = () => interopDefault(import('../../../pages/weddingRingsStackingRings.vue' /* webpackChunkName: "pages/weddingRingsStackingRings" */))
const _7a55fc3a = () => interopDefault(import('../../../pages/weddingRingsStarrySky.vue' /* webpackChunkName: "pages/weddingRingsStarrySky" */))
const _aa14a574 = () => interopDefault(import('../../../pages/weddingRingsTensionRings.vue' /* webpackChunkName: "pages/weddingRingsTensionRings" */))
const _246a6ef7 = () => interopDefault(import('../../../pages/weddingRingstrisets.vue' /* webpackChunkName: "pages/weddingRingstrisets" */))
const _35fb7f12 = () => interopDefault(import('../../../pages/weddingRingsTwoColors.vue' /* webpackChunkName: "pages/weddingRingsTwoColors" */))
const _2d9543ce = () => interopDefault(import('../../../pages/weddingRingsWomen.vue' /* webpackChunkName: "pages/weddingRingsWomen" */))
const _79fa788c = () => interopDefault(import('../../../pages/weddingRingsWaveDesign.vue' /* webpackChunkName: "pages/weddingRingsWaveDesign" */))
const _b69b21b8 = () => interopDefault(import('../../../pages/weddingRingsWhitegold.vue' /* webpackChunkName: "pages/weddingRingsWhitegold" */))
const _ba7dec7c = () => interopDefault(import('../../../pages/engagementRings025Carat.vue' /* webpackChunkName: "pages/engagementRings025Carat" */))
const _c800272c = () => interopDefault(import('../../../pages/engagementRings050Carat.vue' /* webpackChunkName: "pages/engagementRings050Carat" */))
const _746d5c28 = () => interopDefault(import('../../../pages/engagementRings070Carat.vue' /* webpackChunkName: "pages/engagementRings070Carat" */))
const _898bd7f8 = () => interopDefault(import('../../../pages/engagementRings100Carat.vue' /* webpackChunkName: "pages/engagementRings100Carat" */))
const _e85c121e = () => interopDefault(import('../../../pages/engagementRingsBestseller.vue' /* webpackChunkName: "pages/engagementRingsBestseller" */))
const _6ea2ea36 = () => interopDefault(import('../../../pages/engagementRingsDiamond.vue' /* webpackChunkName: "pages/engagementRingsDiamond" */))
const _e50a9dd6 = () => interopDefault(import('../../../pages/engagementRingsBudgetHigh.vue' /* webpackChunkName: "pages/engagementRingsBudgetHigh" */))
const _189aba9e = () => interopDefault(import('../../../pages/engagementRingsBudgetLow.vue' /* webpackChunkName: "pages/engagementRingsBudgetLow" */))
const _03bc36a8 = () => interopDefault(import('../../../pages/engagementRingsBudgetMedium.vue' /* webpackChunkName: "pages/engagementRingsBudgetMedium" */))
const _1e379b18 = () => interopDefault(import('../../../pages/engagementRingsClassic.vue' /* webpackChunkName: "pages/engagementRingsClassic" */))
const _b3a8a2b2 = () => interopDefault(import('../../../pages/engagementRingsCollectionRings.vue' /* webpackChunkName: "pages/engagementRingsCollectionRings" */))
const _1690ad7a = () => interopDefault(import('../../../pages/engagementRingsConfigurator.vue' /* webpackChunkName: "pages/engagementRingsConfigurator" */))
const _183801f5 = () => interopDefault(import('../../../pages/engagementRingsDainty.vue' /* webpackChunkName: "pages/engagementRingsDainty" */))
const _6965fdad = () => interopDefault(import('../../../pages/engagementRingsDiamonds.vue' /* webpackChunkName: "pages/engagementRingsDiamonds" */))
const _276c3000 = () => interopDefault(import('../../../pages/engagementRingsExclusive.vue' /* webpackChunkName: "pages/engagementRingsExclusive" */))
const _353ca0aa = () => interopDefault(import('../../../pages/engagementRingsFancy.vue' /* webpackChunkName: "pages/engagementRingsFancy" */))
const _58a416ee = () => interopDefault(import('../../../pages/engagementRingsGold.vue' /* webpackChunkName: "pages/engagementRingsGold" */))
const _17107aa8 = () => interopDefault(import('../../../pages/engagementRingsHeart.vue' /* webpackChunkName: "pages/engagementRingsHeart" */))
const _39ef36a6 = () => interopDefault(import('../../../pages/engagementRingsModern.vue' /* webpackChunkName: "pages/engagementRingsModern" */))
const _3fada7ba = () => interopDefault(import('../../../pages/engagementRingsPlatinum.vue' /* webpackChunkName: "pages/engagementRingsPlatinum" */))
const _d172ff12 = () => interopDefault(import('../../../pages/engagementRingsPrincess.vue' /* webpackChunkName: "pages/engagementRingsPrincess" */))
const _0c1b7ad3 = () => interopDefault(import('../../../pages/engagementRingsRedgold.vue' /* webpackChunkName: "pages/engagementRingsRedgold" */))
const _3fa02386 = () => interopDefault(import('../../../pages/engagementRingsRosegold.vue' /* webpackChunkName: "pages/engagementRingsRosegold" */))
const _06b1251a = () => interopDefault(import('../../../pages/engagementRingsSignature.vue' /* webpackChunkName: "pages/engagementRingsSignature" */))
const _28766ef8 = () => interopDefault(import('../../../pages/engagementRingsSolitaire.vue' /* webpackChunkName: "pages/engagementRingsSolitaire" */))
const _54de4688 = () => interopDefault(import('../../../pages/engagementRingsVintage.vue' /* webpackChunkName: "pages/engagementRingsVintage" */))
const _5f7f8beb = () => interopDefault(import('../../../pages/engagementRingsWhitegold.vue' /* webpackChunkName: "pages/engagementRingsWhitegold" */))
const _8df1681e = () => interopDefault(import('../../../pages/weddingRingsCeramic.vue' /* webpackChunkName: "pages/weddingRingsCeramic" */))
const _026b8680 = () => interopDefault(import('../../../pages/weddingRingsFacetes.vue' /* webpackChunkName: "pages/weddingRingsFacetes" */))
const _72d71414 = () => interopDefault(import('../../../pages/weddingRingsFacettedConnections.vue' /* webpackChunkName: "pages/weddingRingsFacettedConnections" */))
const _da985468 = () => interopDefault(import('../../../pages/weddingRingsMorningGlow.vue' /* webpackChunkName: "pages/weddingRingsMorningGlow" */))
const _6d6faa70 = () => interopDefault(import('../../../pages/weddingRingsNaturalBeige.vue' /* webpackChunkName: "pages/weddingRingsNaturalBeige" */))
const _c055d54e = () => interopDefault(import('../../../pages/weddingRingsPolar.vue' /* webpackChunkName: "pages/weddingRingsPolar" */))
const _019f95a6 = () => interopDefault(import('../../../pages/weddingRingsSoleil.vue' /* webpackChunkName: "pages/weddingRingsSoleil" */))
const _4ded69a4 = () => interopDefault(import('../../../pages/aboutPlantMyTree.vue' /* webpackChunkName: "pages/aboutPlantMyTree" */))
const _cdfd7504 = () => interopDefault(import('../../../pages/diamondJewelryPresentsYearly.vue' /* webpackChunkName: "pages/diamondJewelryPresentsYearly" */))
const _267bba3e = () => interopDefault(import('../../../pages/diamondJewelryPresentsChristmas.vue' /* webpackChunkName: "pages/diamondJewelryPresentsChristmas" */))
const _eec07d92 = () => interopDefault(import('../../../pages/diamondJewelryPresentsMother.vue' /* webpackChunkName: "pages/diamondJewelryPresentsMother" */))
const _9b5b4b9c = () => interopDefault(import('../../../pages/diamondJewelryPresentsValentine.vue' /* webpackChunkName: "pages/diamondJewelryPresentsValentine" */))
const _267f02ba = () => interopDefault(import('../../../pages/diamondJewelryPresentsWomen.vue' /* webpackChunkName: "pages/diamondJewelryPresentsWomen" */))
const _397fd7c0 = () => interopDefault(import('../../../pages/weddingRingsStylesCool.vue' /* webpackChunkName: "pages/weddingRingsStylesCool" */))
const _5e4ca4b4 = () => interopDefault(import('../../../pages/weddingRingsStylesCreative.vue' /* webpackChunkName: "pages/weddingRingsStylesCreative" */))
const _3b20a697 = () => interopDefault(import('../../../pages/weddingRingsStylesElegant.vue' /* webpackChunkName: "pages/weddingRingsStylesElegant" */))
const _3fa20478 = () => interopDefault(import('../../../pages/weddingRingsStylesLuxury.vue' /* webpackChunkName: "pages/weddingRingsStylesLuxury" */))
const _79ff88fc = () => interopDefault(import('../../../pages/weddingRingsStylesNatural.vue' /* webpackChunkName: "pages/weddingRingsStylesNatural" */))
const _2f9bc330 = () => interopDefault(import('../../../pages/weddingRingsStylesRomantic.vue' /* webpackChunkName: "pages/weddingRingsStylesRomantic" */))
const _4845612a = () => interopDefault(import('../../../pages/weddingRingsStylesUrban.vue' /* webpackChunkName: "pages/weddingRingsStylesUrban" */))
const _e94314c8 = () => interopDefault(import('../../../pages/_item.vue' /* webpackChunkName: "pages/_item" */))
const _5c82c7ce = () => interopDefault(import('../../../pages/_shopsDetails.vue' /* webpackChunkName: "pages/_shopsDetails" */))
const _6cf8147a = () => interopDefault(import('../../../pages/_shoplogin.vue' /* webpackChunkName: "pages/_shoplogin" */))
const _6eabc278 = () => interopDefault(import('../../../pages/_wishlistDetails.vue' /* webpackChunkName: "pages/_wishlistDetails" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/alloys/",
    component: _19c08d12,
    pathToRegexpOptions: {"strict":true},
    name: "metals___nl"
  }, {
    path: "/collecties/",
    component: _a28def82,
    pathToRegexpOptions: {"strict":true},
    name: "collections___nl"
  }, {
    path: "/configurator/",
    component: _7dfb3afb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___nl"
  }, {
    path: "/diamanten/",
    component: _16e72b65,
    pathToRegexpOptions: {"strict":true},
    name: "diamonds___nl"
  }, {
    path: "/en/",
    component: _0fa7fa7c,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/engagementRingsFastDelivery/",
    component: _fc141604,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFastDelivery___nl"
  }, {
    path: "/engraving/",
    component: _4409b1e3,
    pathToRegexpOptions: {"strict":true},
    name: "engraving___nl"
  }, {
    path: "/eternity-rings/",
    component: _4ed97b72,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRings___nl"
  }, {
    path: "/imprint/",
    component: _5e6addb3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___nl"
  }, {
    path: "/juwelen/",
    component: _e54704c8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry___nl"
  }, {
    path: "/locatie/",
    component: _791eaf32,
    pathToRegexpOptions: {"strict":true},
    name: "shops___nl"
  }, {
    path: "/logout/",
    component: _060975c6,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogout___nl"
  }, {
    path: "/magazine/",
    component: _0c066a4c,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___nl"
  }, {
    path: "/memoireRingsFullSizeMemoires/",
    component: _b64031f0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsFullSizeMemoires___nl"
  }, {
    path: "/memoireRingsGrowingMemoires/",
    component: _66c9526e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGrowingMemoires___nl"
  }, {
    path: "/online-consultation/",
    component: _450dc9ef,
    pathToRegexpOptions: {"strict":true},
    name: "onlineConsulting___nl"
  }, {
    path: "/over-acredo/",
    component: _201fc092,
    pathToRegexpOptions: {"strict":true},
    name: "about___nl"
  }, {
    path: "/privacy/",
    component: _0e0fedb2,
    pathToRegexpOptions: {"strict":true},
    name: "privacy___nl"
  }, {
    path: "/raadpleging/",
    component: _0a322188,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___nl"
  }, {
    path: "/ringmaat/",
    component: _40883628,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizes___nl"
  }, {
    path: "/sapphire/",
    component: _27bc6108,
    pathToRegexpOptions: {"strict":true},
    name: "sapphire___nl"
  }, {
    path: "/shopIndividualBeBrussels/",
    component: _c0ed3e02,
    pathToRegexpOptions: {"strict":true},
    name: "shopIndividualBeBrussels___nl"
  }, {
    path: "/sitemap/",
    component: _2608185f,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___nl"
  }, {
    path: "/stijlen/",
    component: _765796b0,
    pathToRegexpOptions: {"strict":true},
    name: "styles___nl"
  }, {
    path: "/sweepstake/",
    component: _81c33258,
    pathToRegexpOptions: {"strict":true},
    name: "sweepstake___nl"
  }, {
    path: "/trouwringen/",
    component: _0cd8a615,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRings___nl"
  }, {
    path: "/urban-mining/",
    component: _afbea128,
    pathToRegexpOptions: {"strict":true},
    name: "urbanMining___nl"
  }, {
    path: "/verlanglijstje/",
    component: _6b2356ea,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist___nl"
  }, {
    path: "/verlovingsringen/",
    component: _83448524,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings___nl"
  }, {
    path: "/zweiklang/",
    component: _6e586682,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklang___nl"
  }, {
    path: "/zweiklangConfigurator/",
    component: _c18d5752,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklangConfigurator___nl"
  }, {
    path: "/about-acredo/packaging/",
    component: _3e27a63c,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPackaging___nl"
  }, {
    path: "/about-acredo/rjc-certification/",
    component: _334c00a4,
    pathToRegexpOptions: {"strict":true},
    name: "aboutRjc___nl"
  }, {
    path: "/collections/engagement-rings/",
    component: _70c0e335,
    pathToRegexpOptions: {"strict":true},
    name: "collectionsEngagementRings___nl"
  }, {
    path: "/configurator/basic/",
    component: _2c7c0ad7,
    pathToRegexpOptions: {"strict":true},
    name: "configuratorV2___nl"
  }, {
    path: "/en/about-acredo/",
    component: _201fc092,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/alloys/",
    component: _19c08d12,
    pathToRegexpOptions: {"strict":true},
    name: "metals___en"
  }, {
    path: "/en/collections/",
    component: _a28def82,
    pathToRegexpOptions: {"strict":true},
    name: "collections___en"
  }, {
    path: "/en/configurator/",
    component: _7dfb3afb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___en"
  }, {
    path: "/en/consultation/",
    component: _0a322188,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___en"
  }, {
    path: "/en/diamonds/",
    component: _16e72b65,
    pathToRegexpOptions: {"strict":true},
    name: "diamonds___en"
  }, {
    path: "/en/engagement-rings/",
    component: _83448524,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings___en"
  }, {
    path: "/en/engagementRingsFastDelivery/",
    component: _fc141604,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFastDelivery___en"
  }, {
    path: "/en/engraving/",
    component: _4409b1e3,
    pathToRegexpOptions: {"strict":true},
    name: "engraving___en"
  }, {
    path: "/en/eternity-rings/",
    component: _4ed97b72,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRings___en"
  }, {
    path: "/en/imprint/",
    component: _5e6addb3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___en"
  }, {
    path: "/en/jewelry/",
    component: _e54704c8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry___en"
  }, {
    path: "/en/location/",
    component: _791eaf32,
    pathToRegexpOptions: {"strict":true},
    name: "shops___en"
  }, {
    path: "/en/logout/",
    component: _060975c6,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogout___en"
  }, {
    path: "/en/magazine/",
    component: _0c066a4c,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___en"
  }, {
    path: "/en/memoireRingsFullSizeMemoires/",
    component: _b64031f0,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsFullSizeMemoires___en"
  }, {
    path: "/en/memoireRingsGrowingMemoires/",
    component: _66c9526e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGrowingMemoires___en"
  }, {
    path: "/en/online-consultation/",
    component: _450dc9ef,
    pathToRegexpOptions: {"strict":true},
    name: "onlineConsulting___en"
  }, {
    path: "/en/privacy/",
    component: _0e0fedb2,
    pathToRegexpOptions: {"strict":true},
    name: "privacy___en"
  }, {
    path: "/en/ringsize/",
    component: _40883628,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizes___en"
  }, {
    path: "/en/sapphire/",
    component: _27bc6108,
    pathToRegexpOptions: {"strict":true},
    name: "sapphire___en"
  }, {
    path: "/en/shopIndividualBeBrussels/",
    component: _c0ed3e02,
    pathToRegexpOptions: {"strict":true},
    name: "shopIndividualBeBrussels___en"
  }, {
    path: "/en/sitemap/",
    component: _2608185f,
    pathToRegexpOptions: {"strict":true},
    name: "sitemap___en"
  }, {
    path: "/en/styles/",
    component: _765796b0,
    pathToRegexpOptions: {"strict":true},
    name: "styles___en"
  }, {
    path: "/en/sweepstake/",
    component: _81c33258,
    pathToRegexpOptions: {"strict":true},
    name: "sweepstake___en"
  }, {
    path: "/en/urban-mining/",
    component: _afbea128,
    pathToRegexpOptions: {"strict":true},
    name: "urbanMining___en"
  }, {
    path: "/en/wedding-rings/",
    component: _0cd8a615,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRings___en"
  }, {
    path: "/en/wishlist/",
    component: _6b2356ea,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist___en"
  }, {
    path: "/en/zweiklang/",
    component: _6e586682,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklang___en"
  }, {
    path: "/engagement-rings/entwined/",
    component: _516d7204,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsEntwined___nl"
  }, {
    path: "/engagement-rings/essentials/",
    component: _078b1b1a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsEssentials___nl"
  }, {
    path: "/engagement-rings/halo/",
    component: _46edee6c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHalo___nl"
  }, {
    path: "/engagement-rings/with-lab-grown-diamonds/",
    component: _4cd8080a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsLabGrownDiamonds___nl"
  }, {
    path: "/engagment-rings/tension/",
    component: _96092af8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsTensionRing___nl"
  }, {
    path: "/engraving/fonts/",
    component: _23b38611,
    pathToRegexpOptions: {"strict":true},
    name: "engravingFonts___nl"
  }, {
    path: "/engraving/inspiration/",
    component: _257a6437,
    pathToRegexpOptions: {"strict":true},
    name: "engravingInspiration___nl"
  }, {
    path: "/engraving/sayings/",
    component: _7941d609,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSayings___nl"
  }, {
    path: "/engraving/symbols/",
    component: _59950db0,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSymbols___nl"
  }, {
    path: "/eternity-rings/bestseller/",
    component: _49ce008a,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBestseller___nl"
  }, {
    path: "/eternity-rings/budget-hoog/",
    component: _4b76baae,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetHigh___nl"
  }, {
    path: "/eternity-rings/budget-laag/",
    component: _75b281f8,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetLow___nl"
  }, {
    path: "/eternity-rings/budget-medium/",
    component: _32dc3e01,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetMedium___nl"
  }, {
    path: "/eternity-rings/cheap/",
    component: _5eb6c510,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsCheap___nl"
  }, {
    path: "/eternity-rings/colored/",
    component: _6aae162b,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsColored___nl"
  }, {
    path: "/eternity-rings/gold/",
    component: _bf2cf172,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGold___nl"
  }, {
    path: "/eternity-rings/half-summarized/",
    component: _448a0cd2,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsHalfSetMemories___nl"
  }, {
    path: "/eternity-rings/platinum/",
    component: _4c214393,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsPlatinum___nl"
  }, {
    path: "/eternity-rings/rood-goud/",
    component: _25487fda,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRedgold___nl"
  }, {
    path: "/eternity-rings/rosegold/",
    component: _26b8ebd4,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRosegold___nl"
  }, {
    path: "/eternity-rings/sets/",
    component: _a32a1d30,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRingsets___nl"
  }, {
    path: "/eternity-rings/signature/",
    component: _ee9df73e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSignature___nl"
  }, {
    path: "/eternity-rings/till-005-carat/",
    component: _48b58cb8,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSlim___nl"
  }, {
    path: "/eternity-rings/till-010-carat/",
    component: _23d7b09c,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsConfigurator___nl"
  }, {
    path: "/eternity-rings/till-025-carat/",
    component: _6e49c747,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsExclusive___nl"
  }, {
    path: "/eternity-rings/trouwringen/",
    component: _2b9a9f70,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsAsWeddingRings___nl"
  }, {
    path: "/eternity-rings/wit-goud/",
    component: _596747d2,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsWhite___nl"
  }, {
    path: "/jewelry/signet/",
    component: _6754ffe8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignet___nl"
  }, {
    path: "/juwelen/025-carat/",
    component: _e9688820,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry025Carat___nl"
  }, {
    path: "/juwelen/05-carat/",
    component: _f6eac2d0,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry050Carat___nl"
  }, {
    path: "/juwelen/07-carat/",
    component: _a357f7cc,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry070Carat___nl"
  }, {
    path: "/juwelen/1-carat/",
    component: _b876739c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry100Carat___nl"
  }, {
    path: "/juwelen/armbanden/",
    component: _6957a8df,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBracelets___nl"
  }, {
    path: "/juwelen/bestseller/",
    component: _7c78d59f,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBestseller___nl"
  }, {
    path: "/juwelen/budget-hoog/",
    component: _7e218fc3,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetHigh___nl"
  }, {
    path: "/juwelen/budget-laag/",
    component: _1c7e3643,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetLow___nl"
  }, {
    path: "/juwelen/budget-medium/",
    component: _662621d6,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetMedium___nl"
  }, {
    path: "/juwelen/collectie-ringen/",
    component: _2a0accb9,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryCollectionRings___nl"
  }, {
    path: "/juwelen/configurator/",
    component: _57219471,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryConfigurator___nl"
  }, {
    path: "/juwelen/delicate-sets/",
    component: _4bd1658e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryDelicateJewels___nl"
  }, {
    path: "/juwelen/diamant-oorbellen/",
    component: _668ae9e9,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryEarrings___nl"
  }, {
    path: "/juwelen/diamanten_halsketting/",
    component: _7f035e85,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryColliers___nl"
  }, {
    path: "/juwelen/exclusief/",
    component: _15157b92,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryExclusive___nl"
  }, {
    path: "/juwelen/goud/",
    component: _0ccb101c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryGold___nl"
  }, {
    path: "/juwelen/platin/",
    component: _283859e8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPlatinum___nl"
  }, {
    path: "/juwelen/rood-goud/",
    component: _e10a6a36,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRedgold___nl"
  }, {
    path: "/juwelen/rosegold/",
    component: _6e8abf2a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRosegold___nl"
  }, {
    path: "/juwelen/sets/",
    component: _2e5600e6,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySets___nl"
  }, {
    path: "/juwelen/signature/",
    component: _2f7cb8ac,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignature___nl"
  }, {
    path: "/juwelen/wit-goud/",
    component: _ef69c106,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryWhitegold___nl"
  }, {
    path: "/over-acredo/duurzaamheid/",
    component: _7adc03be,
    pathToRegexpOptions: {"strict":true},
    name: "aboutSustainability___nl"
  }, {
    path: "/over-acredo/filosofie/",
    component: _051a5ff0,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPhilosophy___nl"
  }, {
    path: "/over-acredo/juwelenproductie/",
    component: _49b867eb,
    pathToRegexpOptions: {"strict":true},
    name: "aboutJewelryManufacturing___nl"
  }, {
    path: "/over-acredo/kwaliteit/",
    component: _1f3e3410,
    pathToRegexpOptions: {"strict":true},
    name: "aboutQuality___nl"
  }, {
    path: "/over-acredo/ontwerp/",
    component: _6597c956,
    pathToRegexpOptions: {"strict":true},
    name: "aboutDesign___nl"
  }, {
    path: "/over-acredo/service/",
    component: _c263bea4,
    pathToRegexpOptions: {"strict":true},
    name: "aboutService___nl"
  }, {
    path: "/over-acredo/trouwringen-productie/",
    component: _8e05f05e,
    pathToRegexpOptions: {"strict":true},
    name: "aboutWeddingRingManufacturing___nl"
  }, {
    path: "/ringmaat/calculator/",
    component: _7648f20e,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesCalculator___nl"
  }, {
    path: "/ringmaat/chart/",
    component: _01fb9972,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesTable___nl"
  }, {
    path: "/stijlen/uw-individuele-stijl/",
    component: _180e6600,
    pathToRegexpOptions: {"strict":true},
    name: "stylesIndividualStyle___nl"
  }, {
    path: "/trouwringe/zwart/",
    component: _0995fd9a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBlack___nl"
  }, {
    path: "/trouwringen/afwerkingen/",
    component: _36047594,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFinishes___nl"
  }, {
    path: "/trouwringen/bestseller/",
    component: _26090a50,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBestseller___nl"
  }, {
    path: "/trouwringen/bos_groen/",
    component: _6cf2fe7e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsForestGreen___nl"
  }, {
    path: "/trouwringen/budget-hoog/",
    component: _22b79608,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetHigh___nl"
  }, {
    path: "/trouwringen/budget-laag/",
    component: _38e585ea,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetLow___nl"
  }, {
    path: "/trouwringen/budget-medium/",
    component: _7ed74662,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetMedium___nl"
  }, {
    path: "/trouwringen/carbon/",
    component: _79c8af62,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCarbon___nl"
  }, {
    path: "/trouwringen/certificaat/",
    component: _1025f4f2,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCertificate___nl"
  }, {
    path: "/trouwringen/configurator/",
    component: _9ce0612c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsConfigurator___nl"
  }, {
    path: "/trouwringen/crown/",
    component: _1403ea52,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCrown___nl"
  }, {
    path: "/trouwringen/diamanten/",
    component: _5b1d4f54,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsDiamonds___nl"
  }, {
    path: "/trouwringen/diversiteit/",
    component: _32b28c5f,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGayLesbianCouples___nl"
  }, {
    path: "/trouwringen/exclusief/",
    component: _317ccb39,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsExclusive___nl"
  }, {
    path: "/trouwringen/fancy/",
    component: _d71dd138,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFancy___nl"
  }, {
    path: "/trouwringen/frame-instellingen/",
    component: _40cb86cb,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFrameSettings___nl"
  }, {
    path: "/trouwringen/gewoon/",
    component: _2fbb69e5,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlain___nl"
  }, {
    path: "/trouwringen/goedkoop/",
    component: _62692b2c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCheap___nl"
  }, {
    path: "/trouwringen/goud/",
    component: _aec757d6,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGold___nl"
  }, {
    path: "/trouwringen/hartje/",
    component: _01880ae2,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsHearts___nl"
  }, {
    path: "/trouwringen/klassiek/",
    component: _19b88fed,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsClassic___nl"
  }, {
    path: "/trouwringen/mannen/",
    component: _3a0c14b1,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMen___nl"
  }, {
    path: "/trouwringen/milgrain/",
    component: _27a01c99,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMillgrif___nl"
  }, {
    path: "/trouwringen/modern/",
    component: _15e5f414,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsModern___nl"
  }, {
    path: "/trouwringen/mokume-gane/",
    component: _5574aaca,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMokumeGane___nl"
  }, {
    path: "/trouwringen/platinum/",
    component: _3164f961,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlatinum___nl"
  }, {
    path: "/trouwringen/ring-sets/",
    component: _d0ede954,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRingSets___nl"
  }, {
    path: "/trouwringen/rose-goud/",
    component: _34efd84c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRedgold___nl"
  }, {
    path: "/trouwringen/rose-goud/",
    component: _5c318038,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRosegold___nl"
  }, {
    path: "/trouwringen/secret-heart/",
    component: _5d970b51,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSecretHeart___nl"
  }, {
    path: "/trouwringen/signature/",
    component: _4be40853,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSignature___nl"
  }, {
    path: "/trouwringen/slank/",
    component: _384ff31c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSlim___nl"
  }, {
    path: "/trouwringen/stapel-ringen/",
    component: _a5165cb8,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStackingRings___nl"
  }, {
    path: "/trouwringen/starry_skies/",
    component: _7a55fc3a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStarrySky___nl"
  }, {
    path: "/trouwringen/tension/",
    component: _aa14a574,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTensionRings___nl"
  }, {
    path: "/trouwringen/trisets/",
    component: _246a6ef7,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingstrisets___nl"
  }, {
    path: "/trouwringen/twee_kleuren/",
    component: _35fb7f12,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTwoColors___nl"
  }, {
    path: "/trouwringen/vrouwen/",
    component: _2d9543ce,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWomen___nl"
  }, {
    path: "/trouwringen/wave/",
    component: _79fa788c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWaveDesign___nl"
  }, {
    path: "/trouwringen/wit-goud/",
    component: _b69b21b8,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWhitegold___nl"
  }, {
    path: "/verlovingsringen/025-carat/",
    component: _ba7dec7c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings025Carat___nl"
  }, {
    path: "/verlovingsringen/05-carat/",
    component: _c800272c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings050Carat___nl"
  }, {
    path: "/verlovingsringen/07-carat/",
    component: _746d5c28,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings070Carat___nl"
  }, {
    path: "/verlovingsringen/1-carat/",
    component: _898bd7f8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings100Carat___nl"
  }, {
    path: "/verlovingsringen/bestseller/",
    component: _e85c121e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBestseller___nl"
  }, {
    path: "/verlovingsringen/brillant/",
    component: _6ea2ea36,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamond___nl"
  }, {
    path: "/verlovingsringen/budget-hoog/",
    component: _e50a9dd6,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetHigh___nl"
  }, {
    path: "/verlovingsringen/budget-laag/",
    component: _189aba9e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetLow___nl"
  }, {
    path: "/verlovingsringen/budget-medium/",
    component: _03bc36a8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetMedium___nl"
  }, {
    path: "/verlovingsringen/classic/",
    component: _1e379b18,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsClassic___nl"
  }, {
    path: "/verlovingsringen/collectie-ringen/",
    component: _b3a8a2b2,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsCollectionRings___nl"
  }, {
    path: "/verlovingsringen/configurator/",
    component: _1690ad7a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsConfigurator___nl"
  }, {
    path: "/verlovingsringen/dainty/",
    component: _183801f5,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDainty___nl"
  }, {
    path: "/verlovingsringen/diamanten/",
    component: _6965fdad,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamonds___nl"
  }, {
    path: "/verlovingsringen/exclusief/",
    component: _276c3000,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsExclusive___nl"
  }, {
    path: "/verlovingsringen/fancy/",
    component: _353ca0aa,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFancy___nl"
  }, {
    path: "/verlovingsringen/goud/",
    component: _58a416ee,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsGold___nl"
  }, {
    path: "/verlovingsringen/hart-ringen/",
    component: _17107aa8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHeart___nl"
  }, {
    path: "/verlovingsringen/modern/",
    component: _39ef36a6,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsModern___nl"
  }, {
    path: "/verlovingsringen/platinum/",
    component: _3fada7ba,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPlatinum___nl"
  }, {
    path: "/verlovingsringen/princess/",
    component: _d172ff12,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPrincess___nl"
  }, {
    path: "/verlovingsringen/rood-goud/",
    component: _0c1b7ad3,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRedgold___nl"
  }, {
    path: "/verlovingsringen/rose-gold/",
    component: _3fa02386,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRosegold___nl"
  }, {
    path: "/verlovingsringen/signature/",
    component: _06b1251a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSignature___nl"
  }, {
    path: "/verlovingsringen/solitaire/",
    component: _28766ef8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSolitaire___nl"
  }, {
    path: "/verlovingsringen/vintage/",
    component: _54de4688,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsVintage___nl"
  }, {
    path: "/verlovingsringen/wit-goud/",
    component: _5f7f8beb,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsWhitegold___nl"
  }, {
    path: "/wedding-rings/ceramic/",
    component: _8df1681e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCeramic___nl"
  }, {
    path: "/wedding-rings/facetes/",
    component: _026b8680,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacetes___nl"
  }, {
    path: "/wedding-rings/facetted-connections/",
    component: _72d71414,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacettedConnections___nl"
  }, {
    path: "/wedding-rings/morning-glow/",
    component: _da985468,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMorningGlow___nl"
  }, {
    path: "/wedding-rings/natural-beige/",
    component: _6d6faa70,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsNaturalBeige___nl"
  }, {
    path: "/wedding-rings/polar/",
    component: _c055d54e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPolar___nl"
  }, {
    path: "/wedding-rings/soleil/",
    component: _019f95a6,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSoleil___nl"
  }, {
    path: "/about-acredo/sustainability/plant-my-tree/",
    component: _4ded69a4,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPlantMyTree___nl"
  }, {
    path: "/en/about-acredo/design/",
    component: _6597c956,
    pathToRegexpOptions: {"strict":true},
    name: "aboutDesign___en"
  }, {
    path: "/en/about-acredo/jewelry-production/",
    component: _49b867eb,
    pathToRegexpOptions: {"strict":true},
    name: "aboutJewelryManufacturing___en"
  }, {
    path: "/en/about-acredo/packaging/",
    component: _3e27a63c,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPackaging___en"
  }, {
    path: "/en/about-acredo/philosophy/",
    component: _051a5ff0,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPhilosophy___en"
  }, {
    path: "/en/about-acredo/quality/",
    component: _1f3e3410,
    pathToRegexpOptions: {"strict":true},
    name: "aboutQuality___en"
  }, {
    path: "/en/about-acredo/rjc-certification/",
    component: _334c00a4,
    pathToRegexpOptions: {"strict":true},
    name: "aboutRjc___en"
  }, {
    path: "/en/about-acredo/service/",
    component: _c263bea4,
    pathToRegexpOptions: {"strict":true},
    name: "aboutService___en"
  }, {
    path: "/en/about-acredo/sustainability/",
    component: _7adc03be,
    pathToRegexpOptions: {"strict":true},
    name: "aboutSustainability___en"
  }, {
    path: "/en/about-acredo/wedding-rings-production/",
    component: _8e05f05e,
    pathToRegexpOptions: {"strict":true},
    name: "aboutWeddingRingManufacturing___en"
  }, {
    path: "/en/collections/engagement-rings/",
    component: _70c0e335,
    pathToRegexpOptions: {"strict":true},
    name: "collectionsEngagementRings___en"
  }, {
    path: "/en/configurator/basic/",
    component: _2c7c0ad7,
    pathToRegexpOptions: {"strict":true},
    name: "configuratorV2___en"
  }, {
    path: "/en/engagement-rings/025-carat/",
    component: _ba7dec7c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings025Carat___en"
  }, {
    path: "/en/engagement-rings/05-carat/",
    component: _c800272c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings050Carat___en"
  }, {
    path: "/en/engagement-rings/07-carat/",
    component: _746d5c28,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings070Carat___en"
  }, {
    path: "/en/engagement-rings/1-carat/",
    component: _898bd7f8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRings100Carat___en"
  }, {
    path: "/en/engagement-rings/bestseller/",
    component: _e85c121e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBestseller___en"
  }, {
    path: "/en/engagement-rings/brillant/",
    component: _6ea2ea36,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamond___en"
  }, {
    path: "/en/engagement-rings/budget-high/",
    component: _e50a9dd6,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetHigh___en"
  }, {
    path: "/en/engagement-rings/budget-low/",
    component: _189aba9e,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetLow___en"
  }, {
    path: "/en/engagement-rings/budget-medium/",
    component: _03bc36a8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsBudgetMedium___en"
  }, {
    path: "/en/engagement-rings/classic/",
    component: _1e379b18,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsClassic___en"
  }, {
    path: "/en/engagement-rings/collection-rings/",
    component: _b3a8a2b2,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsCollectionRings___en"
  }, {
    path: "/en/engagement-rings/configurator/",
    component: _1690ad7a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsConfigurator___en"
  }, {
    path: "/en/engagement-rings/dainty/",
    component: _183801f5,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDainty___en"
  }, {
    path: "/en/engagement-rings/diamonds/",
    component: _6965fdad,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsDiamonds___en"
  }, {
    path: "/en/engagement-rings/entwined/",
    component: _516d7204,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsEntwined___en"
  }, {
    path: "/en/engagement-rings/essentials/",
    component: _078b1b1a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsEssentials___en"
  }, {
    path: "/en/engagement-rings/exclusive/",
    component: _276c3000,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsExclusive___en"
  }, {
    path: "/en/engagement-rings/fancy/",
    component: _353ca0aa,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsFancy___en"
  }, {
    path: "/en/engagement-rings/gold/",
    component: _58a416ee,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsGold___en"
  }, {
    path: "/en/engagement-rings/halo/",
    component: _46edee6c,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHalo___en"
  }, {
    path: "/en/engagement-rings/heart-rings/",
    component: _17107aa8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsHeart___en"
  }, {
    path: "/en/engagement-rings/modern/",
    component: _39ef36a6,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsModern___en"
  }, {
    path: "/en/engagement-rings/platinum/",
    component: _3fada7ba,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPlatinum___en"
  }, {
    path: "/en/engagement-rings/princess/",
    component: _d172ff12,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsPrincess___en"
  }, {
    path: "/en/engagement-rings/red-gold/",
    component: _0c1b7ad3,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRedgold___en"
  }, {
    path: "/en/engagement-rings/rose-gold/",
    component: _3fa02386,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsRosegold___en"
  }, {
    path: "/en/engagement-rings/signature/",
    component: _06b1251a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSignature___en"
  }, {
    path: "/en/engagement-rings/solitaire/",
    component: _28766ef8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsSolitaire___en"
  }, {
    path: "/en/engagement-rings/vintage/",
    component: _54de4688,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsVintage___en"
  }, {
    path: "/en/engagement-rings/white-gold/",
    component: _5f7f8beb,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsWhitegold___en"
  }, {
    path: "/en/engagement-rings/with-lab-grown-diamonds/",
    component: _4cd8080a,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsLabGrownDiamonds___en"
  }, {
    path: "/en/engagment-rings/tension/",
    component: _96092af8,
    pathToRegexpOptions: {"strict":true},
    name: "engagementRingsTensionRing___en"
  }, {
    path: "/en/engraving/fonts/",
    component: _23b38611,
    pathToRegexpOptions: {"strict":true},
    name: "engravingFonts___en"
  }, {
    path: "/en/engraving/inspiration/",
    component: _257a6437,
    pathToRegexpOptions: {"strict":true},
    name: "engravingInspiration___en"
  }, {
    path: "/en/engraving/sayings/",
    component: _7941d609,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSayings___en"
  }, {
    path: "/en/engraving/symbols/",
    component: _59950db0,
    pathToRegexpOptions: {"strict":true},
    name: "engravingSymbols___en"
  }, {
    path: "/en/eternity-rings/bestseller/",
    component: _49ce008a,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBestseller___en"
  }, {
    path: "/en/eternity-rings/budget-high/",
    component: _4b76baae,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetHigh___en"
  }, {
    path: "/en/eternity-rings/budget-low/",
    component: _75b281f8,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetLow___en"
  }, {
    path: "/en/eternity-rings/budget-medium/",
    component: _32dc3e01,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsBudgetMedium___en"
  }, {
    path: "/en/eternity-rings/cheap/",
    component: _5eb6c510,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsCheap___en"
  }, {
    path: "/en/eternity-rings/colored/",
    component: _6aae162b,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsColored___en"
  }, {
    path: "/en/eternity-rings/gold/",
    component: _bf2cf172,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsGold___en"
  }, {
    path: "/en/eternity-rings/half-summarized/",
    component: _448a0cd2,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsHalfSetMemories___en"
  }, {
    path: "/en/eternity-rings/platinum/",
    component: _4c214393,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsPlatinum___en"
  }, {
    path: "/en/eternity-rings/redgold/",
    component: _25487fda,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRedgold___en"
  }, {
    path: "/en/eternity-rings/rosegold/",
    component: _26b8ebd4,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRosegold___en"
  }, {
    path: "/en/eternity-rings/sets/",
    component: _a32a1d30,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsRingsets___en"
  }, {
    path: "/en/eternity-rings/signature/",
    component: _ee9df73e,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSignature___en"
  }, {
    path: "/en/eternity-rings/till-005-carat/",
    component: _48b58cb8,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsSlim___en"
  }, {
    path: "/en/eternity-rings/till-010-carat/",
    component: _23d7b09c,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsConfigurator___en"
  }, {
    path: "/en/eternity-rings/till-025-carat/",
    component: _6e49c747,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsExclusive___en"
  }, {
    path: "/en/eternity-rings/wedding-rings/",
    component: _2b9a9f70,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsAsWeddingRings___en"
  }, {
    path: "/en/eternity-rings/white-gold/",
    component: _596747d2,
    pathToRegexpOptions: {"strict":true},
    name: "memoireRingsWhite___en"
  }, {
    path: "/en/jewelry/025-carat/",
    component: _e9688820,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry025Carat___en"
  }, {
    path: "/en/jewelry/05-carat/",
    component: _f6eac2d0,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry050Carat___en"
  }, {
    path: "/en/jewelry/07-carat/",
    component: _a357f7cc,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry070Carat___en"
  }, {
    path: "/en/jewelry/1-carat/",
    component: _b876739c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelry100Carat___en"
  }, {
    path: "/en/jewelry/bestseller/",
    component: _7c78d59f,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBestseller___en"
  }, {
    path: "/en/jewelry/bracelets/",
    component: _6957a8df,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBracelets___en"
  }, {
    path: "/en/jewelry/budget-high/",
    component: _7e218fc3,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetHigh___en"
  }, {
    path: "/en/jewelry/budget-low/",
    component: _1c7e3643,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetLow___en"
  }, {
    path: "/en/jewelry/budget-medium/",
    component: _662621d6,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryBudgetMedium___en"
  }, {
    path: "/en/jewelry/collection-rings/",
    component: _2a0accb9,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryCollectionRings___en"
  }, {
    path: "/en/jewelry/configurator/",
    component: _57219471,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryConfigurator___en"
  }, {
    path: "/en/jewelry/delicate-sets/",
    component: _4bd1658e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryDelicateJewels___en"
  }, {
    path: "/en/jewelry/diamond-earrings/",
    component: _668ae9e9,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryEarrings___en"
  }, {
    path: "/en/jewelry/diamond-necklace/",
    component: _7f035e85,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryColliers___en"
  }, {
    path: "/en/jewelry/exclusive/",
    component: _15157b92,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryExclusive___en"
  }, {
    path: "/en/jewelry/gold/",
    component: _0ccb101c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryGold___en"
  }, {
    path: "/en/jewelry/platin/",
    component: _283859e8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPlatinum___en"
  }, {
    path: "/en/jewelry/redgold/",
    component: _e10a6a36,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRedgold___en"
  }, {
    path: "/en/jewelry/rosegold/",
    component: _6e8abf2a,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryRosegold___en"
  }, {
    path: "/en/jewelry/sets/",
    component: _2e5600e6,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySets___en"
  }, {
    path: "/en/jewelry/signature/",
    component: _2f7cb8ac,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignature___en"
  }, {
    path: "/en/jewelry/signet/",
    component: _6754ffe8,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelrySignet___en"
  }, {
    path: "/en/jewelry/white-gold/",
    component: _ef69c106,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryWhitegold___en"
  }, {
    path: "/en/ringsize/calculator/",
    component: _7648f20e,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesCalculator___en"
  }, {
    path: "/en/ringsize/chart/",
    component: _01fb9972,
    pathToRegexpOptions: {"strict":true},
    name: "ringSizesTable___en"
  }, {
    path: "/en/styles/your-individual-style/",
    component: _180e6600,
    pathToRegexpOptions: {"strict":true},
    name: "stylesIndividualStyle___en"
  }, {
    path: "/en/trauringe-eheringe/schwarz/",
    component: _0995fd9a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBlack___en"
  }, {
    path: "/en/trauringe-eheringe/zertifikat/",
    component: _1025f4f2,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCertificate___en"
  }, {
    path: "/en/wedding-rings/bestseller/",
    component: _26090a50,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBestseller___en"
  }, {
    path: "/en/wedding-rings/budget-high/",
    component: _22b79608,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetHigh___en"
  }, {
    path: "/en/wedding-rings/budget-low/",
    component: _38e585ea,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetLow___en"
  }, {
    path: "/en/wedding-rings/budget-medium/",
    component: _7ed74662,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsBudgetMedium___en"
  }, {
    path: "/en/wedding-rings/carbon/",
    component: _79c8af62,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCarbon___en"
  }, {
    path: "/en/wedding-rings/ceramic/",
    component: _8df1681e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCeramic___en"
  }, {
    path: "/en/wedding-rings/cheap/",
    component: _62692b2c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCheap___en"
  }, {
    path: "/en/wedding-rings/classic/",
    component: _19b88fed,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsClassic___en"
  }, {
    path: "/en/wedding-rings/configurator/",
    component: _9ce0612c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsConfigurator___en"
  }, {
    path: "/en/wedding-rings/crown/",
    component: _1403ea52,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsCrown___en"
  }, {
    path: "/en/wedding-rings/diamonds/",
    component: _5b1d4f54,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsDiamonds___en"
  }, {
    path: "/en/wedding-rings/diversity/",
    component: _32b28c5f,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGayLesbianCouples___en"
  }, {
    path: "/en/wedding-rings/exclusive/",
    component: _317ccb39,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsExclusive___en"
  }, {
    path: "/en/wedding-rings/facetes/",
    component: _026b8680,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacetes___en"
  }, {
    path: "/en/wedding-rings/facetted-connections/",
    component: _72d71414,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFacettedConnections___en"
  }, {
    path: "/en/wedding-rings/fancy/",
    component: _d71dd138,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFancy___en"
  }, {
    path: "/en/wedding-rings/forest_green/",
    component: _6cf2fe7e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsForestGreen___en"
  }, {
    path: "/en/wedding-rings/frame_settings/",
    component: _40cb86cb,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFrameSettings___en"
  }, {
    path: "/en/wedding-rings/gold/",
    component: _aec757d6,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsGold___en"
  }, {
    path: "/en/wedding-rings/hammered/",
    component: _36047594,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsFinishes___en"
  }, {
    path: "/en/wedding-rings/hearts/",
    component: _01880ae2,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsHearts___en"
  }, {
    path: "/en/wedding-rings/men/",
    component: _3a0c14b1,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMen___en"
  }, {
    path: "/en/wedding-rings/milgrain/",
    component: _27a01c99,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMillgrif___en"
  }, {
    path: "/en/wedding-rings/modern/",
    component: _15e5f414,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsModern___en"
  }, {
    path: "/en/wedding-rings/mokume-gane/",
    component: _5574aaca,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMokumeGane___en"
  }, {
    path: "/en/wedding-rings/morning-glow/",
    component: _da985468,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsMorningGlow___en"
  }, {
    path: "/en/wedding-rings/natural-beige/",
    component: _6d6faa70,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsNaturalBeige___en"
  }, {
    path: "/en/wedding-rings/plain/",
    component: _2fbb69e5,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlain___en"
  }, {
    path: "/en/wedding-rings/platinum/",
    component: _3164f961,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPlatinum___en"
  }, {
    path: "/en/wedding-rings/polar/",
    component: _c055d54e,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsPolar___en"
  }, {
    path: "/en/wedding-rings/red-gold/",
    component: _34efd84c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRedgold___en"
  }, {
    path: "/en/wedding-rings/ring-sets/",
    component: _d0ede954,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRingSets___en"
  }, {
    path: "/en/wedding-rings/rose-gold/",
    component: _5c318038,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsRosegold___en"
  }, {
    path: "/en/wedding-rings/secret-heart/",
    component: _5d970b51,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSecretHeart___en"
  }, {
    path: "/en/wedding-rings/signature/",
    component: _4be40853,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSignature___en"
  }, {
    path: "/en/wedding-rings/slim/",
    component: _384ff31c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSlim___en"
  }, {
    path: "/en/wedding-rings/soleil/",
    component: _019f95a6,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsSoleil___en"
  }, {
    path: "/en/wedding-rings/stacking-rings/",
    component: _a5165cb8,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStackingRings___en"
  }, {
    path: "/en/wedding-rings/starry_skies/",
    component: _7a55fc3a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStarrySky___en"
  }, {
    path: "/en/wedding-rings/tension/",
    component: _aa14a574,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTensionRings___en"
  }, {
    path: "/en/wedding-rings/trisets/",
    component: _246a6ef7,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingstrisets___en"
  }, {
    path: "/en/wedding-rings/two_colors/",
    component: _35fb7f12,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsTwoColors___en"
  }, {
    path: "/en/wedding-rings/wave/",
    component: _79fa788c,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWaveDesign___en"
  }, {
    path: "/en/wedding-rings/white-gold/",
    component: _b69b21b8,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWhitegold___en"
  }, {
    path: "/en/wedding-rings/women/",
    component: _2d9543ce,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsWomen___en"
  }, {
    path: "/en/zweiklang/configurator/",
    component: _c18d5752,
    pathToRegexpOptions: {"strict":true},
    name: "zweiklangConfigurator___en"
  }, {
    path: "/juwelen/presenteert/jaarlijks/",
    component: _cdfd7504,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsYearly___nl"
  }, {
    path: "/juwelen/presenteert/kerstmis/",
    component: _267bba3e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsChristmas___nl"
  }, {
    path: "/juwelen/presenteert/moederdag/",
    component: _eec07d92,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsMother___nl"
  }, {
    path: "/juwelen/presenteert/valentijnsdag/",
    component: _9b5b4b9c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsValentine___nl"
  }, {
    path: "/juwelen/presenteert/vrouwen/",
    component: _267f02ba,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsWomen___nl"
  }, {
    path: "/trouwringen/styles/cool/",
    component: _397fd7c0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCool___nl"
  }, {
    path: "/trouwringen/styles/creatief/",
    component: _5e4ca4b4,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCreative___nl"
  }, {
    path: "/trouwringen/styles/elegant/",
    component: _3b20a697,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesElegant___nl"
  }, {
    path: "/trouwringen/styles/luxe/",
    component: _3fa20478,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesLuxury___nl"
  }, {
    path: "/trouwringen/styles/natuurlijk/",
    component: _79ff88fc,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesNatural___nl"
  }, {
    path: "/trouwringen/styles/romantic/",
    component: _2f9bc330,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesRomantic___nl"
  }, {
    path: "/trouwringen/styles/urban/",
    component: _4845612a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesUrban___nl"
  }, {
    path: "/en/about-acredo/sustainability/plant-my-tree/",
    component: _4ded69a4,
    pathToRegexpOptions: {"strict":true},
    name: "aboutPlantMyTree___en"
  }, {
    path: "/en/jewelry/presents/christmas/",
    component: _267bba3e,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsChristmas___en"
  }, {
    path: "/en/jewelry/presents/forher/",
    component: _267f02ba,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsWomen___en"
  }, {
    path: "/en/jewelry/presents/motherday/",
    component: _eec07d92,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsMother___en"
  }, {
    path: "/en/jewelry/presents/valentinesday/",
    component: _9b5b4b9c,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsValentine___en"
  }, {
    path: "/en/jewelry/presents/yearly/",
    component: _cdfd7504,
    pathToRegexpOptions: {"strict":true},
    name: "diamondJewelryPresentsYearly___en"
  }, {
    path: "/en/wedding-rings/styles/cool/",
    component: _397fd7c0,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCool___en"
  }, {
    path: "/en/wedding-rings/styles/creative/",
    component: _5e4ca4b4,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesCreative___en"
  }, {
    path: "/en/wedding-rings/styles/elegant/",
    component: _3b20a697,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesElegant___en"
  }, {
    path: "/en/wedding-rings/styles/luxury/",
    component: _3fa20478,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesLuxury___en"
  }, {
    path: "/en/wedding-rings/styles/natural/",
    component: _79ff88fc,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesNatural___en"
  }, {
    path: "/en/wedding-rings/styles/romantic/",
    component: _2f9bc330,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesRomantic___en"
  }, {
    path: "/en/wedding-rings/styles/urban/",
    component: _4845612a,
    pathToRegexpOptions: {"strict":true},
    name: "weddingRingsStylesUrban___en"
  }, {
    path: "/",
    component: _0fa7fa7c,
    pathToRegexpOptions: {"strict":true},
    name: "index___nl"
  }, {
    path: "/en/article/:set/",
    component: _e94314c8,
    pathToRegexpOptions: {"strict":true},
    name: "item___en"
  }, {
    path: "/en/location/:town/",
    component: _5c82c7ce,
    pathToRegexpOptions: {"strict":true},
    name: "shopsDetails___en"
  }, {
    path: "/en/login/:shopid/",
    component: _6cf8147a,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogin___en"
  }, {
    path: "/en/wishlist/:wishlistHash/",
    component: _6eabc278,
    pathToRegexpOptions: {"strict":true},
    name: "wishlistDetails___en"
  }, {
    path: "/article/:set/",
    component: _e94314c8,
    pathToRegexpOptions: {"strict":true},
    name: "item___nl"
  }, {
    path: "/locatie/:town/",
    component: _5c82c7ce,
    pathToRegexpOptions: {"strict":true},
    name: "shopsDetails___nl"
  }, {
    path: "/login/:shopid/",
    component: _6cf8147a,
    pathToRegexpOptions: {"strict":true},
    name: "shoplogin___nl"
  }, {
    path: "/verlanglijstje/:wishlistHash/",
    component: _6eabc278,
    pathToRegexpOptions: {"strict":true},
    name: "wishlistDetails___nl"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
